{{#if active}}
<div ref:wrapper class="bespoke-wrapper bespoke-parent">
{{#each slides as slide, i @_id}}
    {{#if $isMobile.any && slide.mobile_type}}
        <:Component {getComponent(slide.mobile_type)} chapter={{name}} :slide :i />
    {{else}}
        <:Component {getComponent(slide.type)} chapter={{name}} :slide :i />
    {{/if}}
{{/each}}

    <Progress total={{ slides.length }} />

</div>
{{/if}}

<script>

import Slide from './Slide.html'
import Video from './Video.html'
import Image from './Image.html'
import Title from './Title.html'
import About from './About.html'
import MapMaj from './slides/MapMaj.html'
import SLRWaves from './slides/SLRWaves.html'
import Gallery from './slides/Gallery.html'
import CO2 from './slides/CO2.html'
import NuclearTimeline from './slides/NuclearTimeline.html'
import SLRProjections from './slides/SLRProjections.html'
import RisingTides from './slides/RisingTides.html'


import MobileSlide from './mobile/slides/MobileSlide.html'
import MobileVideo from './mobile/slides/MobileVideo.html'
import MobileInteractive from './mobile/slides/MobileInteractive.html'

import Progress from './Progress.html'

// try to keep these in rough order of appearance
const SLIDES = {
    // general slide types
    Slide, 
    Video,
    Image,
    Title, 
    Gallery, 
    About,

    // interactive slides
    RisingTides,
    MapMaj, 
    SLRWaves, 
    NuclearTimeline, 
    CO2, 
    SLRProjections,

    // mobile slides
    MobileSlide,
    MobileVideo,
    MobileInteractive,
};

export default {
	components: {
        Slide,
        Progress,
    },

    data() {
        return {
            slides: []
        }
    },

    helpers: {

        getComponent(name) {
            if ( store.get('isMobile').any && (name == 'Video') ) name = 'MobileVideo';
            return SLIDES[name] || Slide;
        }
    },

    computed: {
        active: ($current_chapter, name) => $current_chapter === name
    }
}
</script>
